import { render } from "./PhaseList.vue?vue&type=template&id=5044975e&scoped=true"
import script from "./PhaseList.vue?vue&type=script&lang=js"
export * from "./PhaseList.vue?vue&type=script&lang=js"

import "./PhaseList.vue?vue&type=style&index=0&id=5044975e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5044975e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QBanner,QIcon,QSpinner,QRadio,QExpansionItem,QChip,QTable,QItem});
